import React from 'react'
import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import { SERVICES, COMPANY } from '../data/siteData'
import { PAGE_META } from '../data/metaData'

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-stone-950 text-white">
      <SeoHead
        title={PAGE_META.notFound.title}
        description={PAGE_META.notFound.description}
      />

      <div className="max-w-xl mx-auto text-center">
        <div className="w-16 h-16 rounded-2xl bg-amber-500/20 text-amber-400 flex items-center justify-center mx-auto mb-6 text-3xl font-black">
          404
        </div>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
          Siden blev ikke fundet
        </h1>

        <p className="mt-4 text-stone-300 text-base sm:text-lg leading-relaxed">
          Vi kunne desværre ikke finde den ønskede side. Adressen kan være flyttet, eller linket kan være udløbet.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-[#015205] hover:bg-[#026b07] text-white font-bold text-sm shadow transition-colors"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true"></i>
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-stone-800 hover:bg-stone-700 text-white font-bold text-sm border border-stone-700 transition-colors"
          >
            <i className="fa-solid fa-envelope text-amber-400 text-xs" aria-hidden="true"></i>
            <span>Kontakt Jonas</span>
          </Link>
        </div>

        <div className="mt-12 pt-8 border-t border-stone-800 text-left">
          <p className="text-xs uppercase tracking-wider text-amber-400 font-bold mb-3 text-center">
            Eller udforsk vores ydelser:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
            {SERVICES.map((s) => (
              <Link
                key={s.path}
                to={s.path}
                className="p-3 rounded-lg bg-stone-900 hover:bg-stone-800 border border-stone-800 text-stone-300 hover:text-white transition-colors flex items-center gap-2"
              >
                <i className={`${s.icon} text-amber-500 text-xs`} aria-hidden="true"></i>
                <span>{s.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
